export default "__VITE_ASSET__CUuFoJa6__"